import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const Testimonials = () => {
  return <section className="mb-10" data-id="element-248">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-249">
        Echte Resultaten Van Echte Mensen
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-250">
        Voordat ik vertel hoe de oplossing werkt, wil ik je laten horen van
        mensen die deze transformatie al hebben meegemaakt:
      </p>
      <div className="space-y-6 mb-6" data-id="element-251">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-252">
          <div className="flex mb-3" data-id="element-253">
            <div className="mr-4 flex-shrink-0" data-id="element-254">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1uENzFyeTcPi87ozEBzC5A/Scherm%C2%ADafbeelding_2025-08-15_om_15.51.14.png" alt="Patricia uit Utrecht met haar hond" className="w-16 h-16 rounded-full object-cover" data-id="element-255" />
            </div>
            <div data-id="element-256">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-257" />
              <p className="italic" data-id="element-258">
                "Ik had al veel hondentrainingen gevolgd en certificaten
                gehaald, maar toch kreeg mijn hond gedragsproblemen... De
                training 'Liefdevol communiceren' heeft echt een verschil
                gemaakt. Mijn zelfvertrouwen is gegroeid en ik voel me rustiger.
                De samenwerking is veel prettiger geworden."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-259">
                - Patricia uit Utrecht
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-260">
          <div className="flex mb-3" data-id="element-261">
            <div className="mr-4 flex-shrink-0" data-id="element-262">
              <img src="https://images.unsplash.com/photo-1529429617124-95b109e86bb8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Jan uit Antwerpen met zijn hond" className="w-16 h-16 rounded-full object-cover" data-id="element-263" />
            </div>
            <div data-id="element-264">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-265" />
              <p className="italic" data-id="element-266">
                "De cursus liefdevol communiceren met je hond is echt een
                eyeopener en de communicatie lichaamstaal werkt super goed. Mijn
                hond begrijpt het meteen."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-267">
                - Jan uit Antwerpen
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-268">
          <div className="flex mb-3" data-id="element-269">
            <div className="mr-4 flex-shrink-0" data-id="element-270">
              <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Linda uit Rotterdam met haar hond" className="w-16 h-16 rounded-full object-cover" data-id="element-271" />
            </div>
            <div data-id="element-272">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-273" />
              <p className="italic" data-id="element-274">
                "Sinds ik de cursus 'liefdevol communiceren' volg, voel ik meer
                connectie met mijn honden en kan ik andere honden beter lezen.
                Ik zie nu hoe een hond zich voelt. We ervaren meer rust in
                huis."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-275">
                - Linda uit Rotterdam
              </p>
            </div>
          </div>
        </div>
      </div>
      <p className="text-center text-sm mb-8" data-id="element-276">
        Deze verhalen zijn niet uniek. Met meer dan 15.000 geholpen baasjes en
        100.000+ mensen die mijn webinars hebben bekeken, heb ik een{' '}
        <span className="font-bold" data-id="element-277">
          4,3/5 sterren beoordeling op Trustpilot
        </span>{' '}
        met 584+ reviews.
      </p>
    </section>;
};